import { Component ,  OnInit , Input , AfterViewInit , ViewChild , ElementRef , forwardRef, EventEmitter, Output, HostListener} 	from '@angular/core';
import { ControlValueAccessor  , NG_VALUE_ACCESSOR } 						from '@angular/forms';




@Component({
        standalone: false,
  selector: 'uikit-modal-dialog',
	templateUrl: "./uikit.modal.dialog.html",
	//styleUrls	: [ "./uikit.ext.css" ],
  providers : [ 
				  { 
					  provide: NG_VALUE_ACCESSOR,
					  useExisting: forwardRef(() => UiKitModalDialogComp),
					  multi: true
					}
				]
})
export class UiKitModalDialogComp implements OnInit , AfterViewInit {

			
		@Output() response = new EventEmitter<string>();
		@Output() onClose = new EventEmitter<string>();

		dialogHeader:any = null;
		dialogContent:any = null;
		dialogContentHtml:any = null;
		
		button1:string = "Ok got it";
		button2:string = null;

		_displayModal:boolean = false;

		initialized:boolean = false;
		ownerRef:any = null;
		callback:any = null;

    constructor(private _el: ElementRef){
    }

    ngOnInit(){
		this.initialized=true;
		}
		
		ngAfterViewInit() {
		}
	
		set displayModal( val:boolean ){
			this._displayModal = val;
			//console.info( " set modal display "+ val);
		}

		get displayModal(  ):boolean{
			return this._displayModal ;
		}
		
	clickedClose( button:string ){
		if( this.onClose != null ){
			this.displayModal = false;
			this.onClose.emit( button );
		}
		if( this.ownerRef != null && this.callback != null ){
			this.callback.call( this.ownerRef , button );

		}
		this.ownerRef = null;
		this.callback = null;
	}
}